
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("lkcsM", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");

var $9aYkv = parcelRequire("9aYkv");


var $9wGTI = parcelRequire("9wGTI");


var $e4o8D = parcelRequire("e4o8D");

const $851dc1c722008886$var$HIGHLIGHT_FADE = null;
const $851dc1c722008886$var$notchColorVar = '--notch-color';
const $851dc1c722008886$var$notchStyles = null;
const $851dc1c722008886$var$getElementBeforeColor = (draggableState)=>{
    if (draggableState === 'dragging') return "var(--ds-icon-disabled, #080F214A)";
    return "var(--ds-icon, #292A2E)";
};
// Note: this component extracts the props that we don't want to send to the DOM
// This avoids styled errors about these props being passed to the DOM
/* eslint-disable @typescript-eslint/no-unused-vars */ const $851dc1c722008886$var$ElementBeforeBase = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    let children;
    let props;
    if ($[0] !== t0) {
        const { isSelected: isSelected, draggableState: draggableState, children: t1, ...t2 } = t0;
        children = t1;
        props = t2;
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] !== children || $[4] !== props) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", props, children);
        $[3] = children;
        $[4] = props;
        $[5] = t1;
    } else t1 = $[5];
    return t1;
};
/* eslint-enable @typescript-eslint/no-unused-vars */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $851dc1c722008886$var$ElementBefore = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? $851dc1c722008886$var$ElementBeforeBase : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_42Yu6B7dHp _0adFHsPgdg _2XsHFM1Y8M _3iDTPbQ4SZ _0jFU0VoWWg _39xV02oWWg _0OhMcDDIqT _4CYR7rDIqT _0hPCNLDIqT _37wbyuDIqT _3YEZNOdnbC _1UtDYzoM2E",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $851dc1c722008886$var$ElementAfter = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _3YEZNOdnbC _2XsHFM8HPE",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $851dc1c722008886$var$LinkItemContent = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _39xV02N91d _3iDTPbQ4SZ _4kiQYAoWWg _3hRCZuDIqT _0hPCNLDIqT",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); /**
     *  Use before element + z-index to create a pseudo background. There's no plan to indent the hover and active states
     *  on the main item. The indenting here is still important so that reparenting matches the indent of the "merge"
     *  outline + the drop indicator.
     */ 
const $851dc1c722008886$var$ReparentBackground = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1OimfuzXzM _3dCYwDWVPG _3qT6l0dnbC _3Ku51Iogpp _4diMdqsumd _1lBcDcN91d _35I30BdnbC _1L3m71dnbC _1D2b5MdnbC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $851dc1c722008886$var$TitleSpan = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _2xIroY98eZ _497WNwYbGa _2zndICT6kp _0O93p9HZdu _2O5Vij7dHp _2fwxA5ecOK _3iDTPbQ4SZ _0aFT5vbt8w _42Yu6B7dHp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $851dc1c722008886$export$4a5b409614923c3a = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(17);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "a" : t2;
        const { indent: indent, isSelected: isSelected, forceHoverBackground: forceHoverBackground, isSuperAdmin: isSuperAdmin, item: item, draggableState: draggableState, isDisabled: isDisabled, isQuickActionsFocused: isQuickActionsFocused, ...__cmpldp } = __cmplp;
        const t3 = `calc(100% - ${__cmplp.indent}px)`;
        let t4;
        if ($[3] !== t3) {
            t4 = (0, $9aYkv.default)(t3);
            $[3] = t3;
            $[4] = t4;
        } else t4 = $[4];
        const t5 = `0 0 0 ${__cmplp.indent}px`;
        let t6;
        if ($[5] !== t5) {
            t6 = (0, $9aYkv.default)(t5);
            $[5] = t5;
            $[6] = t6;
        } else t6 = $[6];
        const t7 = `${__cmplp.indent}px`;
        let t8;
        if ($[7] !== t7) {
            t8 = (0, $9aYkv.default)(t7);
            $[7] = t7;
            $[8] = t8;
        } else t8 = $[8];
        const t9 = `-${__cmplp.indent}px`;
        let t10;
        if ($[9] !== t9) {
            t10 = (0, $9aYkv.default)(t9);
            $[9] = t9;
            $[10] = t10;
        } else t10 = $[10];
        let t11;
        if ($[11] !== __cmpls || $[12] !== t10 || $[13] !== t4 || $[14] !== t6 || $[15] !== t8) {
            t11 = {
                ...__cmpls,
                "--_ydnh4o": t4,
                "--_diksfv": t6,
                "--_1loki36": t8,
                "--_1j6sbvc": t10
            };
            $[11] = __cmpls;
            $[12] = t10;
            $[13] = t4;
            $[14] = t6;
            $[15] = t8;
            $[16] = t11;
        } else t11 = $[16];
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: t11,
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_0bjKvDzXzM _30huDKYbGa _2XghbEfQwJ _0Of8r2dnbC _1ZnuxbUNDJ _1wydGWdnbC _2Zuz6QdnbC _2sNsIgmnOE _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _1mT5xdRAKS _3iDTPbQ4SZ _0hPCNLDIqT _0wOv4Q7zJH _39xV02xptJ _0jFU0VUofl _4kiQYAoWWg _24h04i2Njc _3hRCZuDIqT _0KLXrujOvk _4Gpka1jOvk _20VacPYbGa _1UtDYzZpcK _3Ku51IJ5bs _3ScelF5dD1 _125xK89LMr _1lBcDcoWWg _0loxQEN4oS _3WzCGi98eZ _32C2rk98eZ _0DCa9D98eZ _4DXJrK98eZ _0NqVRtYbGa _0i9AWAYbGa _3932vvYbGa _4yBLMOYbGa _3BKYwu6wH8 _0mm6KQ6wH8 _02cRtH6wH8 _2QcX5c6wH8 _0CMRbkZpcK _10n1R5ZpcK _0clgaMZpcK _2nTuUYZpcK _1zr6Dc98eZ _0htemXYbGa _067LceT6kp _0ui43Cs1P7 _1Z6LpTKcZT _2puWMNo126 _1eOmH6o126 _4tNZT5jOvk _0BKJxijOvk _2VmYgUQ4SZ _47e19BQ4SZ _1WpRJ1N91d _41F512N91d _1NqJx8YbGa _1f9PRKYbGa _0tFE10AEMG _0l3XvrAEMG _1wXnwSYbGa _2U5WHpYbGa _3gzVzLY9q9 _1iy5hxY9q9",
                (0, $9wGTI.fg)("platform-dst-motion-uplift-list-item") && "_23rrnHswLo _1B4rbIswLo _3sFUREDGiy _1SdfoHYbGa _2ks4F5YbGa _4jXwANYbGa",
                __cmplp.isSelected && "_0KLXruY9q9 _4Gpka1kLmD _2puWMNsumd _1eOmH6sumd _2n5jUJkLmD _1Z6LpTkLmD",
                __cmplp.isSelected && (0, $9wGTI.fg)("platform-dst-motion-uplift-list-item") && "_23rrnHzzT7 _1B4rbIswLo _3sFUREDGiy _1SdfoHYbGa _2ks4F5YbGa _4jXwANYbGa",
                __cmplp.forceHoverBackground && "_0KLXruo126",
                __cmplp.isSelected && "_0CMRbkjTy9 _10n1R5jTy9 _2nTuUYjTy9 _0clgaM866Z",
                __cmplp.isSuperAdmin && (__cmplp.item.hasRestrictions || __cmplp.item.hasInheritedRestrictions) && "_1UtDYzAyGJ",
                __cmplp.draggableState === "dragging" && "_0EZ2UQot27",
                __cmplp.isDisabled && "_0wOv4Q18ZR _0EZ2UQot27 _0MVbfQVpNL _3gzVzLjOvk _1iy5hxjOvk _1eOmH6jOvk _1ys7EDjOvk",
                __cmplp.forceHoverBackground || __cmplp.isQuickActionsFocused ? "_0uw1WCQ4SZ" : "_0uw1WCYbGa",
                __cmplp.forceHoverBackground || __cmplp.isQuickActionsFocused ? "_3AEWYUN91d" : "_3AEWYUAEMG",
                __cmplp.item.data.status === "DRAFT" && "_0MVbfQVpNL",
                __cmplp.item.data.isHighlighted && "",
                __cmplp.item.data.isHighlighted && "_1gBibypI0X _0nFVCGFSlo _43vdfTHVQb",
                __cmplp.item.data.type === "folder" && __cmplp.draggableState === "dragging" && "_2EE55pot27",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $851dc1c722008886$export$55136cee40306062 = 'page';
const $851dc1c722008886$var$scrollOptions = {
    behavior: 'auto',
    block: 'center',
    inline: 'nearest'
}; // there should be a valid calculated layout for `scrollIntoView`
const $851dc1c722008886$export$10cbe96ec013bef7 = `requestAnimationFrame(function() {
  const selected = document.querySelector('[aria-current="${$851dc1c722008886$export$55136cee40306062}"]');
  if(selected) selected.scrollIntoView(${JSON.stringify($851dc1c722008886$var$scrollOptions)});
  });
  `; /**
      * This needs to be placed at the end of side navigation.
      * Because we need to execute it synchronously to allow scroll to be fast.
      * But we can only execute when everything is parsed in the side bar to get the correct scroll position.
      * Also this script is executed as inline script in SSR result as well as in SPA code to avoid jumping.
      *
      * When blog tree is showing and expanded, it will also use this exact
      * script to scroll to the selected blog tree item. We apply the same focusedAriaCurrentValue to the selected blog tree item.
      */ 
const $851dc1c722008886$export$7a2fdc23a3f02c8a = ()=>{
    const $ = (0, $bDgLe.c)(2);
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = [];
        $[0] = t0;
    } else t0 = $[0];
    (0, $cozmU.useLayoutEffect)($851dc1c722008886$var$_temp, t0);
    if (renderServerPlaceholder) {
        let t1;
        if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
                dangerouslySetInnerHTML: {
                    __html: $851dc1c722008886$export$10cbe96ec013bef7
                }
            });
            $[1] = t1;
        } else t1 = $[1];
        return t1;
    }
    return null;
};
const $851dc1c722008886$export$7a662285bdfa3afe = (t0)=>{
    const $ = (0, $bDgLe.c)(43);
    let afterIcon;
    let beforeIcon;
    let children;
    let dragHandleProps;
    let draggableState;
    let href;
    let indent;
    let isActive;
    let isDisabled;
    let isSelected;
    let passThroughPageTreeLinkProps;
    let t1;
    if ($[0] !== t0) {
        ({ afterIcon: afterIcon, beforeIcon: beforeIcon, children: children, draggableState: draggableState, dragHandleProps: dragHandleProps, indent: indent, isActive: isActive, isSelected: isSelected, renderAs: t1, href: href, isDisabled: isDisabled, ...passThroughPageTreeLinkProps } = t0);
        $[0] = t0;
        $[1] = afterIcon;
        $[2] = beforeIcon;
        $[3] = children;
        $[4] = dragHandleProps;
        $[5] = draggableState;
        $[6] = href;
        $[7] = indent;
        $[8] = isActive;
        $[9] = isDisabled;
        $[10] = isSelected;
        $[11] = passThroughPageTreeLinkProps;
        $[12] = t1;
    } else {
        afterIcon = $[1];
        beforeIcon = $[2];
        children = $[3];
        dragHandleProps = $[4];
        draggableState = $[5];
        href = $[6];
        indent = $[7];
        isActive = $[8];
        isDisabled = $[9];
        isSelected = $[10];
        passThroughPageTreeLinkProps = $[11];
        t1 = $[12];
    }
    const renderAs = t1 === undefined ? "a" : t1;
    const t2 = renderAs === "a" && !isDisabled ? href || "#" : undefined;
    const t3 = isSelected ? $851dc1c722008886$export$55136cee40306062 : undefined;
    const t4 = isActive && !isSelected ? "true" : undefined;
    let t5;
    if ($[13] !== isDisabled) {
        t5 = !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            "aria-hidden": "true",
            className: (0, $hekY6.default)([
                "_1mT5xdWVPG _2I62gz715P _3iC0zdPgdg _39xV024Jdh _0jFU0VxpxF _1VJPcakruI _0KLXruzNEo"
            ])
        });
        $[13] = isDisabled;
        $[14] = t5;
    } else t5 = $[14];
    let t6;
    if ($[15] !== beforeIcon || $[16] !== draggableState || $[17] !== isSelected) {
        t6 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($851dc1c722008886$var$ElementBefore, {
            isSelected: isSelected,
            draggableState: draggableState
        }, beforeIcon);
        $[15] = beforeIcon;
        $[16] = draggableState;
        $[17] = isSelected;
        $[18] = t6;
    } else t6 = $[18];
    let t7;
    if ($[19] !== children) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($851dc1c722008886$var$TitleSpan, null, children);
        $[19] = children;
        $[20] = t7;
    } else t7 = $[20];
    let t8;
    if ($[21] !== afterIcon) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($851dc1c722008886$var$ElementAfter, null, afterIcon);
        $[21] = afterIcon;
        $[22] = t8;
    } else t8 = $[22];
    let t9;
    if ($[23] !== t5 || $[24] !== t6 || $[25] !== t7 || $[26] !== t8) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($851dc1c722008886$var$LinkItemContent, null, t5, t6, t7, t8);
        $[23] = t5;
        $[24] = t6;
        $[25] = t7;
        $[26] = t8;
        $[27] = t9;
    } else t9 = $[27];
    let t10;
    if ($[28] !== draggableState) {
        t10 = draggableState === "parent-of-instruction" ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($851dc1c722008886$var$ReparentBackground, {
            "data-testid": "reparent-background"
        }) : null;
        $[28] = draggableState;
        $[29] = t10;
    } else t10 = $[29];
    let t11;
    if ($[30] !== dragHandleProps || $[31] !== draggableState || $[32] !== indent || $[33] !== isDisabled || $[34] !== isSelected || $[35] !== passThroughPageTreeLinkProps || $[36] !== renderAs || $[37] !== t10 || $[38] !== t2 || $[39] !== t3 || $[40] !== t4 || $[41] !== t9) {
        t11 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($851dc1c722008886$export$4a5b409614923c3a, {
            as: renderAs,
            ...dragHandleProps,
            ...passThroughPageTreeLinkProps,
            href: t2,
            "aria-current": t3,
            "data-testid": "page-tree-item",
            "data-is-active": t4,
            draggableState: draggableState,
            indent: indent,
            isSelected: isSelected,
            isDisabled: isDisabled,
            "aria-disabled": isDisabled
        }, t9, t10);
        $[30] = dragHandleProps;
        $[31] = draggableState;
        $[32] = indent;
        $[33] = isDisabled;
        $[34] = isSelected;
        $[35] = passThroughPageTreeLinkProps;
        $[36] = renderAs;
        $[37] = t10;
        $[38] = t2;
        $[39] = t3;
        $[40] = t4;
        $[41] = t9;
        $[42] = t11;
    } else t11 = $[42];
    return t11;
};
function $851dc1c722008886$var$_temp() {
    if (window.__SSR_RENDERED__) {
        const script = document.createElement("script");
        script.appendChild(document.createTextNode($851dc1c722008886$export$10cbe96ec013bef7));
        document.body.appendChild(script);
        return ()=>{
            document.body.removeChild(script);
        };
    }
}
module.exports["focusedAriaCurrentValue"] = $851dc1c722008886$export$55136cee40306062;
module.exports["FocusToCurrentPageTreeLinkItemSSRInlineScript"] = $851dc1c722008886$export$7a2fdc23a3f02c8a;
module.exports["PageTreeLinkItem"] = $851dc1c722008886$export$7a662285bdfa3afe;

});


//# sourceMappingURL=MovePageDialog.23b32a39.js.map
